import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allTransactionRoutes } from '@/pages/transaction/routes';

export const transactionRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.transaction, action: PermissionAction.enum.view },
  },
  children: [
    ...allTransactionRoutes,
  ],
};
